import React, {PropsWithChildren, useEffect, useState} from "react";
import {Button, Icon, Form, Input, Segment} from "semantic-ui-react";
import {SurveyFormChoice} from "../../model/SurveyFormModel";
import 'react-data-grid/lib/styles.css';
import DataGrid, {Column, EditorProps} from 'react-data-grid';

interface Props {
    choices: SurveyFormChoice[],
    onChanged?: (value: SurveyFormChoice[]) => void;
    readOnly?: boolean;
}

const SurveyFormChoiceList = ({choices, onChanged, readOnly}: Props) => {
    const [rows, setRows] = useState<Object[]>(populateRows());
    const [cols, setCols] = useState<Column<any>[]>(populateCols());

    function onDeleteClick(index: number) {
        if (onChanged) {
            const newChoices = [...choices.filter((_, i) => i !== index)];
            onChanged(newChoices);
        }
    }

    useEffect(() => {
        setCols(populateCols());
        setRows(populateRows());
    }, [choices]);

    function autoFocusAndSelect(input: any) {
        input?.focus();
        input?.select();
    }

    function populateCols(): Column<any>[] {
        let result: Column<any, any>[] = [];
        if (!readOnly) {
            result.push(...[
                    {
                        key: 'addcmd', name: '', minWidth: 48, width: 48, frozen: true, resizable: false,
                        formatter: (row: any) =>
                            (<Button.Group size={"mini"} icon inverted basic compact>
                                <Button onClick={() => onDeleteClick(row["row"]["index"])} compact>
                                    <Icon color={"red"} name={"delete"}/>
                                </Button></Button.Group>),
                        headerRenderer: addCmdHeaderRenderer
                    }
                ]
            );
        }
        result.push(...[
                {
                    key: 'displayText', name: 'Текст ответа', resizable: true, editor: !readOnly ?
                        (props: EditorProps<any>) =>
                            <input
                                ref={autoFocusAndSelect}
                                maxLength={300}
                                value={props.row.displayText}
                                onChange={(e) => props.onRowChange({
                                    ...props.row,
                                    [props.column.key]: e.target.value
                                })}>

                            </input>
                        : null
                },
            ]
        );
        return result;
    }

    function populateRows() {
        return choices?.map((choice, index) => {
            return {
                index: index,
                value: choice.value,
                displayText: choice.displayText
            };
        }) ?? [];
    }

    function getNextCodeIndex() {
        let result = (choices.length + 1);
        while (choices.find((x) => x.value == "V" + result)) {
            result++;
        }
        return result;
    }

    function onAdd() {
        if (choices.length < 50) {
            if (onChanged) {
                const i = getNextCodeIndex();
                const newChoices = [...choices, {value: "V" + i, displayText: "Ответ " + i}];
                onChanged(newChoices);
            }
        }
    }

    function addCmdHeaderRenderer(cprops: PropsWithChildren<any>) {
        return <Button.Group size={"mini"} icon inverted basic compact>
            <Button onClick={onAdd}>
                <Icon name={"add"}
                      color="blue"
                />
            </Button>
        </Button.Group>
    }


    function onRowsChange(rows: Object[]) {
        rows.forEach((row: any) => {
            let index = row["index"] as number;
            if (index >= 0 && index < choices.length) {
                const choice = choices[index];
                choice.value = row.value;
                choice.displayText = row.displayText;
            }
        })
        setRows(populateRows());
    }

    return <Segment>
        <DataGrid columns={cols} rows={rows} className={"rdg-light"} style={{height: "250px"}}
                  onRowsChange={onRowsChange}/>
    </Segment>;
}

export default SurveyFormChoiceList;